import { useState, type FormEvent } from "react";
import Reveal from "@/components/base/Reveal";

const SUBMIT_ADDR = "https://readdy.ai/api/form/daej249tto0ceqqngu90";

const topics = ["社死现场", "职场迷惑", "家庭闹剧", "恋爱修罗场", "游戏名场面", "吃货翻车", "纯纯吐槽/其他"];

type Status = { type: "idle" | "loading" | "success" | "error"; msg?: string };

export default function Contribute() {
  const [status, setStatus] = useState<Status>({ type: "idle" });

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const fd = new FormData(form);

    // honeypot check
    const hp = ((fd.get("website_alt") as string) || "").trim();
    if (hp) {
      setStatus({ type: "success", msg: "投稿收到啦！我们会尽快筛选上架，谢谢贡献笑点。" });
      form.reset();
      return;
    }

    fd.delete("website_alt");
    setStatus({ type: "loading" });

    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: {
        code?: string;
        message?: string;
        meta?: { message?: string; detail?: string };
      } | null = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        /* ignore */
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      const isSpam = /spam/i.test(responseText) || /spam/i.test(serverMsg);

      if (res.ok && parsed?.code === "OK" && !isSpam) {
        setStatus({ type: "success", msg: "投稿收到啦！我们会尽快筛选上架，谢谢你贡献笑点 🍿" });
        form.reset();
      } else {
        setStatus({ type: "error", msg: serverMsg || "投稿失败了，请稍后再试一次。" });
      }
    } catch {
      setStatus({ type: "error", msg: "网络开小差了，请检查网络后重试。" });
    }
  };

  return (
    <section id="contribute" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[960px] px-4 md:px-6">
        <Reveal>
          <div className="overflow-hidden rounded-[2rem] bg-foreground-950">
            <div className="grid md:grid-cols-[1fr_1.1fr]">
              <div className="relative overflow-hidden p-7 md:p-10">
                <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-primary-500/40 blur-3xl"></div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/20 px-3 py-1.5 text-xs font-semibold text-primary-200">
                  <i className="ri-edit-box-line"></i> 吐槽投稿站
                </span>
                <h2 className="mt-4 font-heading text-3xl leading-snug text-background-50 md:text-4xl">
                  你的丢人经历，
                  <br />
                  值得被更多人围观
                </h2>
                <p className="mt-3 max-w-sm text-sm leading-relaxed text-background-50/70 md:text-[15px]">
                  投稿一旦入选，你将成为今天的“快乐赞助商”。放心，我们会自动打码处理，只保留笑点，绝不泄露你的身份。
                </p>
                <ul className="mt-5 space-y-2 text-sm text-background-50/80">
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-accent-400"></i> 剧情够离谱，笑点要拉满
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-accent-400"></i> 涉及他人请征得同意
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-accent-400"></i> 拒绝引战与人身攻击
                  </li>
                </ul>
              </div>

              <form
                data-readdy-form="吐槽投稿表单"
                onSubmit={handleSubmit}
                className="flex flex-col gap-4 rounded-[2rem] bg-background-50 p-6 md:m-3 md:ml-0 md:p-8"
              >
                <div className="grid gap-4 sm:grid-cols-2">
                  <div>
                    <label htmlFor="nickname" className="mb-1.5 block text-sm font-semibold text-foreground-900">
                      你的昵称
                    </label>
                    <input
                      id="nickname"
                      name="nickname"
                      type="text"
                      required
                      maxLength={20}
                      placeholder="怎么称呼你？"
                      className="w-full rounded-xl border border-background-200 bg-background-50 px-4 py-2.5 text-sm outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="mb-1.5 block text-sm font-semibold text-foreground-900">
                      联系邮箱
                    </label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      required
                      placeholder="选上了好通知你"
                      className="w-full rounded-xl border border-background-200 bg-background-50 px-4 py-2.5 text-sm outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="topic" className="mb-1.5 block text-sm font-semibold text-foreground-900">
                    你的社死属于哪一趴
                  </label>
                  <select
                    id="topic"
                    name="topic"
                    required
                    className="w-full rounded-xl border border-background-200 bg-background-50 px-4 py-2.5 text-sm outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                  >
                    {topics.map((t) => (
                      <option key={t} value={t}>
                        {t}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label htmlFor="message" className="mb-1.5 block text-sm font-semibold text-foreground-900">
                    展开说说（别害羞）
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    placeholder="把时间、地点、人物和你的名场面写清楚，越具体越好笑～"
                    className="w-full resize-none rounded-xl border border-background-200 bg-background-50 px-4 py-2.5 text-sm outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                  ></textarea>
                  <p className="mt-1 text-right text-xs text-foreground-400">最多 500 字</p>
                </div>

                {/* anti-spam honeypot */}
                <div className="field-website_alt" aria-hidden="true">
                  <label htmlFor="website_alt">请不要填写此字段</label>
                  <input
                    id="website_alt"
                    name="website_alt"
                    type="text"
                    tabIndex={-1}
                    autoComplete="off"
                    readOnly
                  />
                </div>

                <button
                  type="submit"
                  disabled={status.type === "loading"}
                  className="mt-1 flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3.5 text-base font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70"
                >
                  {status.type === "loading" ? (
                    <>
                      <i className="ri-loader-4-line animate-spin"></i> 正在打包你的名场面…
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-line"></i> 提交投稿，快乐共享
                    </>
                  )}
                </button>

                {status.type === "success" && (
                  <p className="flex items-start gap-2 rounded-xl bg-accent-100 px-4 py-3 text-sm text-accent-900" role="status">
                    <i className="ri-checkbox-circle-line mt-0.5"></i> {status.msg}
                  </p>
                )}
                {status.type === "error" && (
                  <p className="flex items-start gap-2 rounded-xl bg-primary-100 px-4 py-3 text-sm text-primary-800" role="alert">
                    <i className="ri-error-warning-line mt-0.5"></i> {status.msg}
                  </p>
                )}
              </form>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}